import { useRouter } from "next/router";
import { useEffect } from "react";
import { useState } from "react";
import { inquirySet } from "../../../api/products";
import { failAlert } from "../../../common/alert";
import { getCookie } from "../../../common/auth";
import InquiryCompleteModal from "../../elements/inquiryCompleteModal";
import Layout from "../../layout/Layout";
import DesignInquiryModal from "./designInquiryModal";
import DesginReferenceModal from "./designReferenceModal";
import * as D from "./DesignService-styles";
import { connect } from "react-redux";
import { isLoaded, isLoading } from "../../../redux/action/loading";
import modalOverflowHook from "../../../common/modalOverflowHook";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const designArr = [
  {
    title: "베이직 A",
    desc: (
      <>
        <span>간단한 교정 또는 재배치 디자인</span>
        <span>
          (
          <strong>
            로고와 패키지디자인이 <br /> ai파일로 보유한 상태
          </strong>
          )
        </span>
      </>
    ),
    m_desc: (
      <>
        <span>간단한 교정 또는 재배치 디자인</span>
        <span>
          (
          <strong>
            로고와 패키지디자인이
            <br /> ai파일로 보유한 상태
          </strong>
          )
        </span>
      </>
    ),
    img: "/assets/imgs/page/design/basicA.png",
    price: "30,000",
    checkArr: [
      { img: "/assets/imgs/page/design/check_on.png", content: "디자인 교정" },
      { img: "/assets/imgs/page/design/check_on.png", content: "간단한 배치" },
      {
        img: "/assets/imgs/page/design/check_off.png",
        content: "로고(일러스트)",
      },
      {
        img: "/assets/imgs/page/design/check_off.png",
        content: "브랜드 디자인",
      },
    ],
    code: "P1111",
    referenceInfo: [
      <p>
        <strong>ai 패키지 디자인 파일</strong>보유 시,
        <strong> 교정 및 배치</strong>만 필요하다면 베이직 디자인 서비스를
        추천합니다.
      </p>,
      <p>
        <strong>봉투포장재의</strong> 인쇄 서비스입니다.
      </p>,
    ],
    referenceRange: (
      <p>
        <strong>디자인 일부 교정 </strong>또는 새로운 패키지에 맞춘{" "}
        <strong>디자인이나 텍스트 재배치</strong>
      </p>
    ),
    reference: [
      "https://file.caretbio.com/caretbio/fa53c0204daf0a879bb08ae0882cf610.png",
    ],
    comment: (
      <>
        <span>디자인 시안 1개, 수정 2번</span>
        <span>(한 건당 1~5일 소요)</span>
      </>
    ),
  },
  {
    title: "베이직 B",
    desc: (
      <>
        <span>간단한 교정 또는 재배치 디자인</span>
        <span>
          (
          <strong>
            로고와 패키지디자인이 <br /> ai파일로 보유한 상태
          </strong>
          )
        </span>
      </>
    ),
    m_desc: (
      <>
        <span>간단한 교정 또는 재배치 디자인</span>
        <span>
          (
          <strong>
            로고와 패키지디자인이
            <br /> ai파일로 보유한 상태
          </strong>
          )
        </span>
      </>
    ),
    img: "/assets/imgs/page/design/basicB.png",
    price: "50,000",
    checkArr: [
      { img: "/assets/imgs/page/design/check_on.png", content: "디자인 교정" },
      { img: "/assets/imgs/page/design/check_on.png", content: "간단한 배치" },
      {
        img: "/assets/imgs/page/design/check_off.png",
        content: "로고(일러스트)",
      },
      {
        img: "/assets/imgs/page/design/check_off.png",
        content: "브랜드 디자인",
      },
    ],
    code: "P1111",
    referenceInfo: [
      <p>
        <strong>ai 패키지 디자인 파일</strong>보유 시,
        <strong> 교정 및 배치</strong>만 필요하다면 베이직 디자인 서비스를
        추천합니다.
      </p>,
      <p>
        <strong>FSC로고</strong>와 <strong> 스텝포넷제로 마크 </strong>모두{" "}
        <strong>인쇄 가능</strong>합니다.
      </p>,
    ],
    referenceRange: (
      <p>
        <strong>디자인 일부 교정 </strong>또는 새로운 패키지에 맞춘{" "}
        <strong>디자인이나 텍스트 재배치</strong>
      </p>
    ),
    reference: [
      "https://file.caretbio.com/caretbio/b0bed1423a9bcee44c9035b74a7fa445.jpeg",
    ],
    comment: (
      <>
        <span>디자인 시안 1개, 수정 2번</span>
        <span>(한 건당 1~5일 소요)</span>
      </>
    ),
  },
  {
    title: "스탠다드",
    desc: (
      <>
        <span>브랜드 이미지에 맞는 디자인 업그레이드</span>
        <span>
          (<strong>로고ai파일을 보유한 상태</strong>)
        </span>
      </>
    ),
    m_desc: (
      <>
        <span>브랜드 이미지에 맞는 디자인 업그레이드</span>
        <span>
          (<strong>로고ai파일을 보유한 상태</strong>)
        </span>
      </>
    ),
    img: "/assets/imgs/page/design/standard.png",
    price: "300,000",

    checkArr: [
      {
        img: "/assets/imgs/page/design/check_on.png",
        content: "디자인 교정 & 배치",
      },
      { img: "/assets/imgs/page/design/check_on.png", content: "패키지디자인" },
      {
        img: "/assets/imgs/page/design/check_on.png",
        content: "로고(일러스트)",
      },
      {
        img: "/assets/imgs/page/design/check_off.png",
        content: "브랜드 디자인",
      },
    ],
    code: "P1112",
    referenceInfo: [
      <p>
        기본 소유하던 패키지 디자인이 아닌{" "}
        <strong>
          {" "}
          브랜드의 이미지나 컨셉을 활용하여 새롭게 디자인을 원하는 분들께{" "}
        </strong>
        스탠다드 디자인 서비스를 추천합니다.
      </p>,
      <p>
        <strong>FSC로고</strong>와 <strong> 스텝포넷제로 마크 </strong>모두{" "}
        <strong>인쇄 가능</strong>합니다.
      </p>,
    ],
    referenceRange: (
      <p>
        <strong>브랜드 이미지</strong>에 맞춰
        <strong> 원하는 색상으로 패키지 디자인 </strong>업그레이드
      </p>
    ),
    reference: [
      "https://file.caretbio.com/caretbio/d8017bdf784b6829ca9f0e3aab79bfa3.jpeg",
    ],
    comment: (
      <>
        <span>디자인 시안 2개, 수정 2번</span>
        <span>(한 건당 3~9일 소요)</span>
      </>
    ),
  },
  {
    title: "브랜드",
    desc: (
      <>
        <span>전체적인 브랜드 디자인</span>
        <span>
          (<strong>전반적인 디자인 리뉴얼이 필요한 상태</strong>)
        </span>
      </>
    ),
    m_desc: (
      <>
        <span>전체적인 브랜드 디자인</span>
        <span>
          (<strong>전반적인 디자인 리뉴얼이 필요한 상태</strong>)
        </span>
      </>
    ),
    img: "/assets/imgs/page/design/brand.png",
    price: "500,000",

    checkArr: [
      {
        img: "/assets/imgs/page/design/check_on.png",
        content: "디자인 교정 & 배치",
      },
      { img: "/assets/imgs/page/design/check_on.png", content: "패키지디자인" },
      {
        img: "/assets/imgs/page/design/check_on.png",
        content: "로고(일러스트)",
      },
      {
        img: "/assets/imgs/page/design/check_on.png",
        content: "브랜드 디자인",
      },
    ],
    code: "P1113",
    referenceInfo: [
      <p>
        브랜드 새내기 또는
        <strong> 브랜드 디자인의 전반적인 리뉴얼이 필요한 경우 </strong>브랜드
        디자인 서비스를 추천합니다.
      </p>,
      <p>
        <strong>FSC로고</strong>와 <strong> 스텝포넷제로 마크 </strong>모두{" "}
        <strong>인쇄 가능</strong>합니다.
      </p>,
    ],
    referenceRange: (
      <p>
        로고, 패키지 등 관련<strong> 디자인 전반</strong>
      </p>
    ),
    reference: [
      "https://file.caretbio.com/caretbio/9382cbb95fe82274922756744c5a3620.jpeg",
    ],
    comment: (
      <>
        <span>디자인 시안 2개, 수정 2번</span>
        <span>(세부사항 별도 문의)</span>
      </>
    ),
  },
];

const DesignService = ({ isLoaded, isLoading }) => {
  const router = useRouter();
  const [openInquiryModal, setOpenInquiryModal] = useState(false);
  const [inquiryInputs, setInquiryInputs] = useState({});
  // 문의 완료
  const [openInquiryComplete, setOpenInquiryComplete] = useState(false);
  const [openReference, setOpenReference] = useState(false);
  const [activeType, setActiveType] = useState("");
  // 제작 문의
  const onClickInquiry = async () => {
    if (!getCookie("token")) {
      failAlert("로그인 후 사용 가능합니다.");
      setTimeout(() => {
        router.push("/login");
      }, 500);
    } else {
      setOpenInquiryModal((prev) => !prev);
      setInquiryInputs({});
    }
  };

  const onChangeInquiry = (id) => (e) => {
    if (id.includes("file")) {
      setInquiryInputs({ ...inquiryInputs, [id]: e.target.files[0] });
      return;
    }
    setInquiryInputs({ ...inquiryInputs, [id]: e.target.value });
  };

  const onClickInquiryComplete = () => {
    setOpenInquiryComplete((prev) => !prev);
  };

  // 제작 문의 등록
  const submitInquiry = async () => {
    if (
      !inquiryInputs.name ||
      inquiryInputs.name === "" ||
      !inquiryInputs.tel ||
      inquiryInputs.tel === "" ||
      !inquiryInputs.company ||
      inquiryInputs.company === "" ||
      !inquiryInputs.cnt ||
      inquiryInputs.cnt === "" ||
      !inquiryInputs.usages ||
      inquiryInputs.usages === "" ||
      !inquiryInputs.option_1 ||
      inquiryInputs.option_1 === "" ||
      !inquiryInputs.option_2 ||
      inquiryInputs.option_2 === "" ||
      !inquiryInputs.option_3 ||
      inquiryInputs.option_3 === "" ||
      !inquiryInputs.content ||
      inquiryInputs.content === ""
    ) {
      failAlert("항목을 전부 입력해주세요.");
      return;
    }
    if (
      !inquiryInputs.tel.match(
        /^(0[2-8][0-5]?|01[01346-9])-?([1-9]{1}[0-9]{2,3})-?([0-9]{4})$/
      )
    ) {
      failAlert("사용가능한 전화번호를 입력해주세요.");
      return;
    }
    isLoading();
    const body = {
      modes: "InquirySet",
      division: "D",
      pcode: "P000000",
      ...inquiryInputs,
    };
    const res = await inquirySet(body);
    if (res.Code === "0000") {
      onClickInquiryComplete();
      onClickInquiry();
      setInquiryInputs({});
      isLoaded();
    } else {
      failAlert("문의 등록에 실패했습니다.");
      isLoaded();
    }
  };

  // 레퍼런스
  const handleReference = (el) => {
    setActiveType(el);
    setOpenReference((prev) => !prev);
  };

  const modalScrollHook = modalOverflowHook(
    openInquiryModal || openInquiryComplete || openReference
  );

  return (
    <>
      <Layout
        parent={"홈"}
        sub="맞춤제작"
        subTitle={"디자인 서비스"}
        pageTitle={SeoMeta.designService.title}
        pageDesc={SeoMeta.designService.description}
        pageKeyword={SeoMeta.designService.keywords}
      >
        <D.Container>
          <D.Background />
          <D.HeadWrapper>
            <D.CommonTitle>
              <h2>디자인 서비스</h2>
              <D.CommonUnderBar />
            </D.CommonTitle>
          </D.HeadWrapper>
          <D.BodyWrapper className="container">
            {designArr &&
              designArr.map((el, i) => (
                <D.PriceBox key={i}>
                  <div className="title_desc">
                    <h6 className="title">{el.title}</h6>
                    <div className="desc_image_price_p">
                      <div className="desc">{el.desc}</div>
                      <div>
                        <div className="image">
                          <img src={el.img} />
                        </div>
                        <div className="price">
                          <span>
                            <h3>{el.price}</h3>원
                          </span>
                          <p>(VAT 별도)</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* pc */}
                  <div className="image_price_check">
                    <div>
                      <ul className="check">
                        {el.checkArr.map((check, i) => (
                          <li key={i}>
                            <span>
                              <img src={check.img} alt="check" />
                            </span>
                            <span
                              className={`${
                                check.img.includes("on") && "active"
                              }`}
                            >
                              {check.content}
                            </span>
                          </li>
                        ))}
                      </ul>
                      <div className="comment">{el.comment}</div>
                      <div className="confirm">
                        <span onClick={() => handleReference(el)}>
                          <span className="tip box">자세히 보기</span>
                          <img
                            className="on"
                            src="https://file.caretbio.com/caretbio/182da3a0c1adc2fefa3a62705ef29ae6.png"
                          />
                          <img
                            className="off"
                            src="https://file.caretbio.com/caretbio/49ed80f02ab51a797d2c02579e73d687.png"
                          />
                        </span>
                        <button className="btn" onClick={onClickInquiry}>
                          문의하기
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* 모바일 */}
                  <div className="md_m">
                    <div className="desc_image_m">
                      <div className="desc">{el.m_desc}</div>
                      <div className="image">
                        <img src={el.img} />
                      </div>
                    </div>
                    <div className="check_comment_m">
                      <ul className="check">
                        {el.checkArr.map((check, i) => (
                          <li key={i}>
                            <span>
                              <img src={check.img} alt="check" />
                            </span>
                            <span
                              className={`${
                                check.img.includes("on") && "active"
                              }`}
                            >
                              {check.content}
                            </span>
                          </li>
                        ))}
                      </ul>
                      <div className="comment">{el.comment}</div>
                    </div>
                  </div>
                  <div className="m_under_bar" />
                  <div className="price_m">
                    <div className="price">
                      <span>
                        <h3>{el.price}</h3>원
                      </span>
                      <p>(VAT 별도)</p>
                    </div>
                    <div className="confirm">
                      <span onClick={() => handleReference(el)}>
                        <img
                          className="on"
                          src="https://file.caretbio.com/caretbio/182da3a0c1adc2fefa3a62705ef29ae6.png"
                        />
                        <img
                          className="off"
                          src="https://file.caretbio.com/caretbio/49ed80f02ab51a797d2c02579e73d687.png"
                        />
                      </span>
                      <button className="btn" onClick={onClickInquiry}>
                        문의하기
                      </button>
                    </div>
                  </div>
                </D.PriceBox>
              ))}
          </D.BodyWrapper>
        </D.Container>
      </Layout>
      {openInquiryModal && (
        <DesignInquiryModal
          onClickInquiry={onClickInquiry}
          openInquiryModal={openInquiryModal}
          submitInquiry={submitInquiry}
          onChangeInquiry={onChangeInquiry}
          inquiryInputs={inquiryInputs}
        />
      )}
      {openInquiryComplete && (
        <InquiryCompleteModal onClickInquiryComplete={onClickInquiryComplete} />
      )}
      {openReference && (
        <DesginReferenceModal
          handleReference={handleReference}
          activeType={activeType}
        />
      )}
    </>
  );
};
const mapDispatchToProps = {
  isLoading,
  isLoaded,
};

export default connect(null, mapDispatchToProps)(DesignService);
